import { useState } from 'react';

import { Card } from '@ui';
import { Form } from 'components/Form/base/Form';
import { FormDivider, FormInput } from 'components/Form/next';
import { MessageTemplate } from 'components/MessageManagement/types';
import Joi from 'joi';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../../hooks/useApi';
import { TemplatePreview } from './TemplatePreview';

interface Props {
    template?: MessageTemplate;
    clubSlug: string;
    callback?: (newTemplate: MessageTemplate) => void;
}

export const TemplateForm = ({ template, clubSlug, callback }: Props) => {
    const { t } = useTranslation('message-management');
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `message-management/template/${template?.id || clubSlug}`,
            method: template ? 'PUT' : 'POST',
            data,
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback?.(data)
        });
    };

    const schema = Joi.object({
        title: Joi.string().required().label(t('template.form.titleLabel'))
    }).unknown();

    return (
        <Form
            onSubmit={handleSubmit}
            validationSchema={schema}
            defaultValues={{
                colors: {
                    textColor: '#718096',
                    titleColor: '#555555',
                    buttonColor: '#2d3748'
                },
                ...template
            }}
        >
            <div className="tw-container tw-grid tw-grid-cols-2 tw-gap-5">
                <div className="tw-grid">
                    <Card>
                        <div>
                            <h5>{t('template.form.settingsTitle')}</h5>
                        </div>
                        <FormDivider />
                        <div>
                            <FormInput name="title" label={t('template.form.titleLabel')} />
                            <FormDivider />
                            <FormInput.Color name="colors.textColor" label={t('template.form.textColorLabel')} />
                            <FormInput.Color name="colors.titleColor" label={t('template.form.titleColorLabel')} />
                            <FormInput.Color name="colors.buttonColor" label={t('template.form.buttonColorLabel')} />
                            <FormInput.Color
                                name="colors.footerTextColor"
                                label={t('template.form.footerTextColorLabel')}
                            />

                            <FormInput.Code name="htmlHeader" label={t('template.form.htmlHeaderLabel')} />
                            <FormInput.Code name="htmlFooter" label={t('template.form.htmlFooterLabel')} />

                            <FormInput.Submit isLoading={isLoading}></FormInput.Submit>
                        </div>
                    </Card>
                </div>
                <div className="tw-grid">
                    <TemplatePreview />
                </div>
            </div>
        </Form>
    );
};
